
const getCharacterRowSpaceByWindow = (windowWidth, shown) => {
	let containerWidth = 0;
	let fontSize = 0;
	let summaryFontSize = 0;

	/*windowWidth if values are from https://semantic-ui.com/elements/container.html*/
	if(windowWidth > 1200 ) {
		fontSize=11.5
		summaryFontSize= 11 *6.5/10
		containerWidth = 1127
	}else if( windowWidth <= 1200 && windowWidth >= 992 ) {
		fontSize=11
		summaryFontSize= 10.5 *6.5/10
		containerWidth = 933
	}else if( windowWidth <= 991 && windowWidth >= 768 ) {
		fontSize=10.5
		summaryFontSize= 9.5 *6.5/10
		containerWidth = 723
	}else if( windowWidth < 768 ) {
		fontSize=9.5
		summaryFontSize= 9 *6.5/10
		containerWidth = windowWidth-28
	}

	let space = (containerWidth/shown ) -15 /*-15 for margin*/
	let summarySpace = (containerWidth/shown ) -15 /*-15 for margin*/

	// Remove ceil?
	space = Math.ceil(space / fontSize)
	summarySpace = Math.ceil(summarySpace / summaryFontSize)

	return {space, summarySpace};
}

const getTruncatedString = (space, inputString, numOfLines) => {
	let strings = inputString.trim().replace(/\s/g, " ").split(" ");

	let currentLineString = "";
	let currentLineLength = 0;
	let currentLine = 1;
	let lineRows = [];
	
	const ELLIPSISSPACE = 3;
	const PADDINGSPACE = 0.5;
	const minLength = space / 2;
	const NBSP = '\u00A0';

	for (let i = 0; i < strings.length; i++) {
		let currentWord = strings[i];

		// Checks if current word fits in the available space of the current line
		if (currentLineLength + currentWord.length + PADDINGSPACE < space) {
			// Checks if there are words already in the current line
			if (currentLineLength > 0) {
				currentLineString += NBSP;
				currentLineLength ++;
			}

			// Append the current word to the current line
			currentLineString += currentWord;
			currentLineLength += currentWord.length
		} else {
			// If the current word will exceed the available space of the current line if appended

			if (currentLineLength < minLength || (currentWord.length > space && currentLineLength < minLength)) {

				// Checks if there are words already in the current line 
				if (currentLineLength > 0) {
					currentLineString += NBSP;
					currentLineLength ++;
				}
				
				// Cut the current word, add ellipsis and append the to current line
				// Length of the cut word is based on the remaining space
				currentLineString += currentWord.substring(0, space - currentLineLength - ELLIPSISSPACE) + "...";

				lineRows.push(currentLineString)
				currentLineString = "";
				
				// Stop loop if it is already the last line
				if (currentLine === numOfLines) break;

				// Go to next line
				currentLine++;
				// Reset line
				currentLineLength = 0;
			} else if (currentLine === numOfLines) {
				// If it is already the last line, append an ellipsis
				currentLineString += "...";
				
				lineRows.push(currentLineString)
				currentLineString = "";
				break;
			} else {
				// Otherwise go to next line, to process the word again

				lineRows.push(currentLineString)
				currentLineString = "";
				currentLine++;
				currentLineLength = 0;
				i--;
			}
		}
		
	}

	if (currentLineString.length > 0) {
		lineRows.push(currentLineString)
	}
	
	return lineRows.join(" ");
}

module.exports = {
	getCharacterRowSpaceByWindow,
	getTruncatedString
}
